module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v(_vm._s(_vm.title) + " "), _c('small', [_vm._v(_vm._s(_vm.info))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70ad9432"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lte/IboxTitle.vue
// module id = 467
// module chunks = 1